import { useState } from 'react';
import { ChevronDown, ChevronRight, Sparkles } from 'lucide-react';
import { ProvenanceAssistantMessage } from './ProvenanceAssistantMessage';
import type { AgentHistoryItem } from './provenance-entry-item';

export interface ProvenanceReasoningCardProps {
  item: Extract<AgentHistoryItem, { kind: 'reasoning_section' }>;
}

export function ProvenanceReasoningCard({ item }: ProvenanceReasoningCardProps) {
  const [expanded, setExpanded] = useState(true);
  const hasBody = item.body.trim().length > 0;

  if (!hasBody) {
    return (
      <div className="w-full text-xs text-muted-foreground inline-flex items-center gap-2">
        <Sparkles className="h-3.5 w-3.5 shrink-0" />
        <span className="italic">{item.title}</span>
      </div>
    );
  }

  return (
    <div className="w-full" data-testid={`speak2me-reasoning-section-${item.iteration}`}>
      <button
        type="button"
        onClick={() => setExpanded((p) => !p)}
        className="w-full text-xs text-muted-foreground inline-flex items-center gap-2 hover:text-foreground transition-colors text-left"
      >
        {expanded ? (
          <ChevronDown className="h-3.5 w-3.5 shrink-0" />
        ) : (
          <ChevronRight className="h-3.5 w-3.5 shrink-0" />
        )}
        <Sparkles className="h-3.5 w-3.5 shrink-0" />
        <span className="italic">{item.title}</span>
      </button>
      {expanded ? (
        <div className="mt-2 pl-5 border-l-2 border-muted text-xs text-muted-foreground leading-snug">
          <ProvenanceAssistantMessage text={item.body} density="compact" />
        </div>
      ) : null}
    </div>
  );
}
